function isCanadaCountry(country) {
  // no country selected yet -> not Canada, matches index.js's isCanadaSelected() default (TC-1590)
  if (!country) return false;
  const countryObj = !!country && typeof country.toJS === 'function' ? country.toJS() : country;
  const name = countryObj.label || countryObj.value || '';
  return name.toLowerCase() === 'canada';
}

function mapCanadaBankFields(data) {
  const bankBranchCode = data.institutionNumber
    ? `${data.institutionNumber || ''}${data.bsbNumber || ''}`
    : data.bsbNumber || '';
  return {
    bankAccountName: data.accountHolder,
    bankAccountNumber: data.accountNumber,
    bankBranchName: data.branch,
    bankBranchCode,
    bankName: data.nameOfBank,
    bankCodeType: 'Bank Code',
  };
}

function mapTrawickBankFields(data) {
  const countryDetails = !!data.country && typeof data.country.toJS === 'function' ? data.country.toJS() : data.country;
  return {
    bankName: data.bank,
    bankBranchCode: data.bankTypeCode === 'SWIFT Code' ? data.swiftCode : data.bankTypeCode === 'Bank Code' ? data.bankCodeOrRoutingNumber : '',
    bankBranchName: data.bankBranch,
    bankRoutingNumber: data.bankCodeOrRoutingNumber,
    bankAccountName: data.bankAccountName,
    bankAccountNumber: data.bankAccountNumber,
    bankCodeType: data.bankTypeCode,
    bankAddress: data.bankAddress,
    bankPostcode: data.bankPostcode,
    bankSuburbOrCity: data.bankSuburbOrCity,
    IBAN: data.bankTypeCode === 'IBAN' ? data.iban : null,
    fBankCountry: countryDetails ? countryDetails.id : null,
  };
}

function mapCheckFields(data) {
  return {
    creditorName: data.firstName,
    creditorSurname: data.lastName,
    creditorFullName: `${data.firstName || ''} ${data.lastName || ''}`.trim(),
    physicalAddress1: data.addressLine1,
    physicalAddress2: data.addressLine2,
    physicalAddress3: data.city,
    physicalAddress4: data.state,
    physicalCode: data.postalZipCode,
    titleID: data.title,
    cellNumber: data.mobile,
  };
}

/**
 * Maps dynamic payment form values (keyed by API FieldName) to the claim contract fields.
 * API FieldNames: BankBranchCode, BankBranchName, BankName, BankAddress, BankSuburb,
 *                 BankPostCode, BankAccountName, BankAccountNumber, IsInvalidBsb, IBAN
 * Note: there is no 'SwiftCode' FieldName in the DB config - SWIFT Code countries store the
 * code under BankBranchCode too, so bankCodeType must come from the selected PaymentCodeType,
 * not be guessed from which FieldNames are present (TC-1590).
 */
function mapDynamicBankFields(dynamicFormValues, selectedCodeType) {
  if (!dynamicFormValues || Object.keys(dynamicFormValues).length === 0) {
    return {};
  }

  const bankCodeType = selectedCodeType || 'Bank Code';
  const iban = dynamicFormValues.IBAN || '';
  // BankBranchCode is the real SWIFT value entered by the user - keep it as-is even for IBAN
  // countries (previously overwritten with the IBAN value, losing the SWIFT code) - TC-1590
  const bankBranchCode = dynamicFormValues.BankBranchCode || '';

  return {
    bankName: dynamicFormValues.BankName || '',
    bankBranchCode,
    bankBranchName: dynamicFormValues.BankBranchName || '',
    bankRoutingNumber: bankBranchCode,
    bankAccountName: dynamicFormValues.BankAccountName || '',
    bankAccountNumber: dynamicFormValues.BankAccountNumber || '',
    bankCodeType,
    bankAddress: dynamicFormValues.BankAddress || '',
    bankPostcode: dynamicFormValues.BankPostCode || '',
    bankSuburbOrCity: dynamicFormValues.BankSuburb || '',
    IBAN: bankCodeType === 'IBAN' ? iban : null,
    invalidBSB: !!dynamicFormValues.IsInvalidBsb,
  };
}

function resolveSelectedCodeType(data) {
  const codeTypes = data.dynamicPaymentCodeTypes || [];
  const selected = codeTypes.find((c) => c.id === data.selectedCodeTypeId);
  return selected ? selected.codeType : null;
}

function mapToParentSection(data) {
  const countryDetails = !!data.country && typeof data.country.toJS === 'function' ? data.country.toJS() : data.country;
  const isCanada = isCanadaCountry(data.country);
  const isCheckPayment = data.isCheckPayment === true;
  // Use dynamic form mapping when dynamicPaymentFormFields are loaded (DYNAMIC_PAYMENT_FORM=true).
  // When DYNAMIC_PAYMENT_FORM=false, dynamicPaymentFormFields stays empty → falls back to old logic.
  const hasDynamicForm = data.dynamicPaymentFormFields && data.dynamicPaymentFormFields.length > 0;

  // Base fields (GST, other insurance - always included)
  const baseFields = {
    ABNNumber: data.abn,
    gstRegistered: data.registerForGSTPurpose,
    gstPercentageClaimed: data.percentageOfGST,
    claimInputTaxCredit: data.claimITC,
    country: countryDetails ? countryDetails.id : null,
    creditorExtension: {
      payToEntity: data.paymentTo,
      paymentVia: data.paymentVia || 'EFT',
    },
  };

  // Bank fields depend on whether dynamic form, static Canada, static Trawick, or check payment
  let bankFields = {};
  if (!isCheckPayment) {
    if (isCanada) {
      bankFields = mapCanadaBankFields(data);
    } else if (hasDynamicForm) {
      bankFields = mapDynamicBankFields(data.dynamicFormValues, resolveSelectedCodeType(data));
    } else {
      bankFields = mapTrawickBankFields(data);
    }
  }

  // Check/address fields when check payment is selected
  const checkFields = isCheckPayment ? mapCheckFields(data) : {};

  return {
    ...baseFields,
    ...bankFields,
    ...checkFields,
  };
}

function mapToQuestionnaire(data, claimCode) {
  return [
    {
      question: 'section1.otherInsurance',
      answer: data.otherInsurance,
      claimTypeCode: claimCode,
    },
    {
      question: 'section1.provideDetails',
      answer: data.provideDetails,
      claimTypeCode: claimCode,
    },
  ];
}

function mapToExpenses() {
  return [];
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepAppsureBankDetailsDataMapper.js